import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classes", "disabled", "field", "id", "items", "message"],
    _excluded2 = ["value"];
import React, { Fragment } from 'react';
import { arrayOf, number, node, oneOfType, shape, string } from 'prop-types';
import { RadioGroup as InformedRadioGroup } from 'informed';
import useFieldState from '@magento/peregrine/lib/hooks/hook-wrappers/useInformedFieldStateWrapper';
import { useStyle } from '../../classify';
import { Message } from '../Field';
import Radio from './radio';
import defaultClasses from './radioGroup.module.css';

var RadioGroup = function RadioGroup(props) {
  var children = props.children,
      propClasses = props.classes,
      disabled = props.disabled,
      field = props.field,
      id = props.id,
      items = props.items,
      message = props.message,
      rest = _objectWithoutProperties(props, _excluded);

  var fieldState = useFieldState(field);
  var classes = useStyle(defaultClasses, propClasses);
  var options = children || items.map(function (_ref) {
    var value = _ref.value,
        item = _objectWithoutProperties(_ref, _excluded2);

    return React.createElement(Radio, _extends({
      key: value,
      disabled: disabled
    }, item, {
      classes: {
        label: classes.radioLabel,
        root: classes.radioContainer
      },
      id: "".concat(field, "--").concat(value),
      value: value
    }));
  });
  return React.createElement(Fragment, null, React.createElement("div", {
    className: classes.root
  }, React.createElement(InformedRadioGroup, _extends({}, rest, {
    field: field,
    id: id
  }), options)), React.createElement(Message, {
    className: classes.message,
    fieldState: fieldState
  }, message));
};

export default RadioGroup;
RadioGroup.propTypes = {
  children: node,
  classes: shape({
    message: string,
    radioContainer: string,
    radioLabel: string,
    root: string
  }),
  field: string.isRequired,
  id: string,
  items: arrayOf(shape({
    key: oneOfType([number, string]),
    label: node,
    value: oneOfType([number, string])
  })),
  message: node
};